<template>
	<SectionCard>
		<template #title>
			Service Banner
		</template>
		<template #body>
			<v-row dense>
				<v-col cols="12">
					<TextField
						:value="service.policyLinkText"
						label="Policy Link Text"
						:rules="{required: false, max: 50}"
						:disabled="!userCanCreateUpdate"
						@input="updateService('policyLinkText', $event)"
					/>
				</v-col>
			</v-row>

			<v-row dense>
				<v-col cols="6">
					<TextField
						:value="service.imprintLinkText"
						label="Imprint Link Text"
						:rules="{required: false, max: 50}"
						:disabled="!userCanCreateUpdate"
						@input="updateService('imprintLinkText', $event)"
					/>
				</v-col>
				<v-col cols="6">
					<TextField
						:value="service.imprintURL"
						label="Imprint URL"
						:rules="{required: false, max: 2000}"
						:disabled="!userCanCreateUpdate"
						@input="updateService('imprintURL', $event)"
					/>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col cols="6">
					<TextField
						:value="service.categoriesTab"
						label="Categories Tab Text"
						:rules="{required: false, max: 50}"
						:disabled="!userCanCreateUpdate"
						@input="updateService('categoriesTab', $event)"
					/>
				</v-col>
				<v-col cols="6">
					<TextField
						:value="service.servicesTab"
						label="Services Tab Text"
						:rules="{required: false, max: 50}"
						:disabled="!userCanCreateUpdate"
						@input="updateService('servicesTab', $event)"
					/>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col cols="12">
					<TextField
						:value="service.serviceDescriptionHeading"
						label="Service Description Heading"
						:rules="{required: false, max: 50}"
						:tooltip-text="`This is the header used for the 'Service Description' portion of the service element of the service banner`"
						:disabled="!userCanCreateUpdate"
						@input="updateService('serviceDescriptionHeading', $event)"
					/>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col cols="12">
					<Textarea
						:value="service.serviceDescriptionText"
						label="Service Description Text"
						:rules="{required: false, max: 1000}"
						:tooltip-text="`This is the sub-title text used for the 'Service Description' portion of the service element of the service banner`"
						:disabled="!userCanCreateUpdate"
						:rows="3"
						@input="updateService('serviceDescriptionText', $event)"
					/>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col cols="6">
					<TextField
						:value="service.processPurposesHeading"
						label="Processing Purposes Heading"
						:rules="{required: false, max: 50}"
						:tooltip-text="`This is the heading used in the service banner for the Processing Purposes section`"
						:disabled="!userCanCreateUpdate"
						@input="updateService('processPurposesHeading', $event)"
					/>
				</v-col>
				<v-col cols="6">
					<TextField
						:value="service.dataProcessesHeading"
						label="Processed Data Categories Heading"
						:rules="{required: false, max: 50}"
						:disabled="!userCanCreateUpdate"
						@input="updateService('dataProcessesHeading', $event)"
					/>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col cols="6">
					<Textarea
						:value="service.processPurposesDescription"
						label="Processing Purposes Description"
						:rules="{required: false, max: 1000}"
						:tooltip-text="`This is the description used in the service banner for the Processing Purposes section`"
						:disabled="!userCanCreateUpdate"
						:rows="3"
						@input="updateService('processPurposesDescription', $event)"
					/>
				</v-col>
				<v-col cols="6">
					<Textarea
						:value="service.dataProcessesDescription"
						label="Processed Data Categories Description"
						:rules="{required: false, max: 1000}"
						:disabled="!userCanCreateUpdate"
						:rows="3"
						@input="updateService('dataProcessesDescription', $event)"
					/>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col cols="12">
					<TextField
						:value="service.storedInformationHeading"
						label="Stored Information Heading"
						:rules="{required: false, max: 50}"
						:disabled="!userCanCreateUpdate"
						@input="updateService('storedInformationHeading', $event)"
					/>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col cols="12">
					<Textarea
						:value="service.storedInformationDescription"
						label="Stored Information Description"
						:rules="{required: false, max: 1000}"
						:disabled="!userCanCreateUpdate"
						:rows="3"
						@input="updateService('storedInformationDescription', $event)"
					/>
				</v-col>
			</v-row>
			<v-row dense>
				<v-col cols="4">
					<TextField
						:value="service.servicePrivacyPolicyHeading"
						label="Service Policy Heading"
						:rules="{required: false, max: 100}"
						:tooltip-text="`This is the heading used for the service's privacy policy URL, where available`"
						:disabled="!userCanCreateUpdate"
						@input="updateService('servicePrivacyPolicyHeading', $event)"
					/>
				</v-col>
				<v-col cols="4">
					<TextField
						:value="service.typeHeading"
						label="Type Heading"
						:rules="{required: false, max: 50}"
						:disabled="!userCanCreateUpdate"
						@input="updateService('typeHeading', $event)"
					/>
				</v-col>
				<v-col cols="4">
					<TextField
						:value="service.retentionHeading"
						label="Retention Period Heading"
						:rules="{required: false, max: 50}"
						:disabled="!userCanCreateUpdate"
						@input="updateService('retentionHeading', $event)"
					/>
				</v-col>
			</v-row>
		</template>
	</SectionCard>
</template>

<script>
import SectionCard from '../../../../../../../shared/components/section-card.vue'
import TextField from '../../../../../../../shared/components/text-field.vue'
import Textarea from '../../../../../../../shared/components/textarea.vue'

export default {
	components: {
		SectionCard,
		TextField,
		Textarea
	},
	props: {
		service: Object,
		userCanCreateUpdate: Boolean
	},
	methods: {
		updateService (property, value) {
			this.$emit('update:service', {
				...this.service,
				[property]: value
			})
		}
	}
}
</script>
